import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { escalate } from "./thunks/escalate";
import { listAmbassadors } from "./thunks/list-ambassadors";
import { listQueue } from "./thunks/list-queue";
import { loadMaxAttempts } from "./thunks/load-max-attempts";
import { reprogram } from "./thunks/reprogram";

const name = "reschedules";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listQueue.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(listQueue.fulfilled, (state, action) => {
        state.queue = action.payload;
        state.isPending = false;
      })
      .addCase(listQueue.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      .addCase(listAmbassadors.fulfilled, (state, action) => {
        state.ambassadors = action.payload;
      })
      // A cap that cannot be read keeps the default: the backend is what
      // enforces it, and the queue still has to say where each delivery stands.
      .addCase(loadMaxAttempts.fulfilled, (state, action) => {
        state.maxAttempts = action.payload;
      });

    for (const thunk of [reprogram, escalate]) {
      builder
        .addCase(thunk.pending, (state) => {
          state.isActing = true;
          state.actionError = "";
        })
        .addCase(thunk.fulfilled, (state) => {
          state.isActing = false;
        })
        .addCase(thunk.rejected, (state, action) => {
          state.isActing = false;
          state.actionError = action.error.message ?? "";
        });
    }
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
